import React from "react";
import useProductDetailPageAttrQuery from "../hooks/useProductDetailPageAttrQuery";
import { Box, SimpleGrid } from "@chakra-ui/react";
import MediaModal from "@modules/Layout/components/MediaModal";
import ResourceCardItem from "@modules/Resource/components/ResourceCardItem";
import ResponsiveContainer from "@modules/Layout/components/ResponsiveContainer";
import useMediaModal from "@modules/Resource/hooks/useMediaModal";

const Resource = () => {
  const { isOpen, handleOpenModal, handleCloseModal, mediaType, mediaUrl } =
    useMediaModal();

  const { data: result } = useProductDetailPageAttrQuery();
  const {
    resources: { data: resourceCategories },
  } = result!.data.attributes;

  return (
    <Box pb={20}>
      <SimpleGrid columns={{ base: 1, md: 2, lg: 3 }} spacing={7} my={20}>
        {resourceCategories.map((item, index) => (
          <Box key={index}>
            <ResourceCardItem
              item={item}
              isOpen={isOpen}
              handleCloseModal={handleCloseModal}
              handleOpenModal={handleOpenModal}
            />
          </Box>
        ))}
      </SimpleGrid>

      <MediaModal
        type={mediaType}
        url={mediaUrl}
        isOpen={isOpen}
        handleCloseModal={handleCloseModal}
      />
    </Box>
  );
};
export default Resource;
